export enum NoteEntityType {
  'CONTACT' = 'CONTACT',
  'PATIENT' = 'PATIENT',
  'DOCTOR' = 'DOCTOR',
  'FACILITY' = 'FACILITY',
}
